import React, { useRef, useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FetchHotelDetails, selectHotelData, selectresultLoading } from "./HotelSlice";
import CancellationPolicyPopup from "./CancellationPolicyPopup";
import { AlertCircle, Bed, CheckCircle, Users, X, Star, Check, Mail, Download, MessageSquareShare, Share2 } from "lucide-react";
import HotelDetailsComponent from "../../components/HotelDetailsComponent";
import HotelDetailsShimmer from "./HotelDetailsShimmer";
import HotelWhatsAppShare from "./HotelWhatsAppShare";
import CancellationPolicyModal from "./CancellationPolicyModal";


function HotelDetails() {
    const location = useLocation();
    const dispatch = useDispatch();
    const [ids, setIds] = useState({ bookingId: "", requestId: "" });
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [selectedDate, setSelectedDate] = useState({ checkIn: "2025-10-14", checkOut: "2025-10-15" });
    const [activeTab, setActiveTab] = useState("hotels");

    const aboutRef = useRef(null);
    const roomRef = useRef(null);
    const abouthotelref = useRef(null);
    const facilitiesRef = useRef(null);
    const locationRef = useRef(null);
    const policyRef = useRef(null);
    const selectHotelDatas = useSelector(selectHotelData);
    const resultLoading = useSelector(selectresultLoading);
    const HotelDetails = selectHotelDatas && selectHotelDatas.status.success && selectHotelDatas.HotelDetails
    const RoomInfos = selectHotelDatas && selectHotelDatas.status.success && selectHotelDatas.RoomInfo
    const CurrencySymbol = selectHotelDatas && selectHotelDatas.status.success && selectHotelDatas.searchQuery.searchQuery.searchCriteria.currency || "INR"
    const searchQuery = selectHotelDatas && selectHotelDatas.status.success && selectHotelDatas.searchQuery.searchQuery

    const [showCancellationPopup, setShowCancellationPopup] = useState(false);
    const [selectedRoomGroup, setSelectedRoomGroup] = useState(null);
    const [hotelData, sethotelData] = useState(null);

    const handleCancellationClick = (roomGroup) => {
        setSelectedRoomGroup(roomGroup);
        setShowCancellationPopup(true);
    };

    const handleScroll = (ref, tab) => {
        setActiveTab(tab);
        ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };


    const FetchDetails = async (payload) => {
        try { await dispatch(FetchHotelDetails(payload)).unwrap(); }
        catch (err) { console.error("Fetch failed:", err); }
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const parts = location.pathname.split("/").filter(Boolean);
        const bookingId = parts[parts.length - 2];
        const requestId = parts[parts.length - 1];

        const checkIn = searchParams.get("checkIn");
        const checkOut = searchParams.get("checkOut");
        const currency = searchParams.get("currency") || "INR";
        const nationality = searchParams.get("nationality");
        const rooms = JSON.parse(searchParams.get("rooms") || "[]");
        const payload = {
            Request: {
                correlationId: bookingId,
                hid: requestId,
                checkIn,
                checkOut,
                rooms,
                currency,
                nationality,
                timeoutMs: 13000,
            },
            BookingID: bookingId,
            currency: {
                CurrencyRate: "1.000000",
                CurrencyTitle: currency,
                CurrencyId: 1,
            },
        };

        const hoteldetails = FetchDetails({ FormData: payload });
        // const hoteldetails = FetchDetails({ FormData: { Request: {correlationId:bookingId, hid: requestId,currency:"INR" }, BookingID: bookingId, currency: { CurrencyRate: "1", CurrencyTitle: "INR", CurrencyId: 1 } } });

        setIds({ bookingId, requestId });
    }, [location.pathname]);

    useEffect(() => {
        const sections = [
            { id: "hotels", ref: abouthotelref },
            { id: "rooms", ref: roomRef },
            { id: "facilities", ref: facilitiesRef },
            { id: "location", ref: locationRef },
            { id: "policy", ref: policyRef }
        ];
        const handleActiveSection = () => {
            const scrollY = window.scrollY + 150;
            for (let i = sections.length - 1; i >= 0; i--) {
                const section = sections[i].ref.current;
                if (section && scrollY >= section.offsetTop) {
                    setActiveTab(sections[i].id);
                    break;
                }
            }
        };
        window.addEventListener("scroll", handleActiveSection);
        return () => window.removeEventListener("scroll", handleActiveSection);
    }, []);

    const handleHotelCheckout = (roomGroup, room) => {
        const selectedRoom = room || (roomGroup && roomGroup.Rooms && roomGroup.Rooms[0])
        const RoomId = selectedRoom && selectedRoom.id
        const BookingID = HotelDetails.searchId
        const HotelID = HotelDetails.id
        const reviewHash = roomGroup && roomGroup.reviewHash
        window.location.href = `/hotel/checkout/${BookingID}/${HotelID}/${RoomId}?reviewHash=${encodeURIComponent(reviewHash || "")}`;
    }
    const [showGuestPopup, setShowGuestPopup] = useState(false);

    const [selectedRooms, setSelectedRooms] = useState([]);
    const [addMarkup, setAddMarkup] = useState(false);
    const [quotes, setQuotes] = useState({});

    useEffect(() => {
        sethotelData(selectHotelDatas);
    }, [resultLoading, selectHotelDatas]);

    useEffect(() => {
        if (hotelData?.RoomInfo?.length > 0) {
            const allRoomIds = hotelData.RoomInfo.map(
                (item) => item.RoomId
            );

            // Select all rooms when hotel data loads
            setSelectedRooms(allRoomIds);
        } else {
            setSelectedRooms([]);
        }
    }, [hotelData]);

    // All room IDs
    const allRoomIds =
        hotelData?.RoomInfo?.map((item) => item.RoomId) || [];

    // Checkbox states derived from selectedRooms
    const isAllChecked =
        allRoomIds.length > 0 &&
        selectedRooms.length === allRoomIds.length;

    const isHotelChecked =
        selectedRooms.length > 0;


    // Single room checkbox
    const handleSingleCheck = (roomId) => {
        setSelectedRooms((prev) => {
            if (prev.includes(roomId)) {
                return prev.filter((id) => id !== roomId);
            }

            return [...prev, roomId];
        });
    };


    // Master checkbox
    const handleCheckAll = () => {
        if (isAllChecked) {
            setSelectedRooms([]);
        } else {
            setSelectedRooms(allRoomIds);
        }
    };

    // Clear All
    const handleClearAll = () => {
        setSelectedRooms([]);
    };


    // Quote
    const handleQuoteChange = (roomId, value) => {
        if (!/^\d*\.?\d*$/.test(value)) {
            return;
        }

        setQuotes((prev) => ({
            ...prev,
            [roomId]: value,
        }));
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCancelPolicy, setSelectedCancelPolicy] = useState([]);

    const handleOpenModal = (cancelArrayData) => {
        setSelectedCancelPolicy(cancelArrayData);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedCancelPolicy([]);
    };
    return (
        <div className="w-full min-h-screen bg-gray-50">
            {/* <div className="relative w-full h-[450px]">
                <Carousel showThumbs={false} infiniteLoop autoPlay interval={3500} showStatus={false}>
                    {HotelDetails && HotelDetails.img.length > 0 && HotelDetails.img.map((image, i) => <div key={i}><img src={image.url} alt={`Hotel ${i + 1}`} className="object-cover h-[450px] w-full rounded-b-lg" /></div>)}
                </Carousel>
            </div> */}
            <CancellationPolicyModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                cancelArr={selectedCancelPolicy}
            />
            {showGuestPopup && (
                <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50">
                    <div className="mx-4 flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-xl">

                        {/* Header */}
                        <div className="flex shrink-0 items-center justify-between border-b border-slate-100 p-3">
                            <h3 className="text-lg font-semibold text-slate-800">
                                Review hotel list & share details
                            </h3>

                            <button
                                onClick={() => setShowGuestPopup(false)}
                                className="rounded-full p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700"
                            >
                                <X className="h-5 w-5" />
                            </button>
                        </div>

                        {/* Informational Subheader */}
                        <div className="shrink-0 border-b border-gray-100 bg-gray-50/70 px-6 py-2.5 text-xs text-gray-500">
                            You need to login on whatsapp web to be able to share these Hotel(s)
                            to your customer&apos;s whatsapp number.
                        </div>

                        {/* Controls Toolbar */}
                        <div className="flex shrink-0 items-center justify-between border-b border-gray-100 px-6 py-3.5">
                            <span className="text-sm font-semibold text-gray-800">
                                {selectedRooms.length} options added
                            </span>

                            {/* <div className="flex items-center gap-3">
                                <button
                                    onClick={() => setAddMarkup(!addMarkup)}
                                    className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${addMarkup ? 'bg-orange-500' : 'bg-gray-300'
                                        }`}
                                >
                                    <span
                                        className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${addMarkup ? 'translate-x-4' : 'translate-x-0'
                                            }`}
                                    />
                                </button>

                                <span className="text-sm text-gray-700">
                                    Add Markup
                                </span>
                            </div> */}
                        </div>

                        {/* ONLY THIS AREA SCROLLS */}
                        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-4">

                            {/* Hotel Summary */}
                            <div className="flex items-start justify-between">
                                <div>
                                    <p className="text-xs text-gray-400">
                                        Hotels, {hotelData.HotelDetails.ad.city.name}
                                    </p>

                                    <h3 className="mt-0.5 text-lg font-bold text-gray-900">
                                        {hotelData.HotelDetails.name}
                                    </h3>

                                    <div className="mt-1 flex items-center gap-1 text-xs text-gray-500">
                                        <span>
                                            {hotelData.HotelDetails.ad.city.name}
                                        </span>

                                        <span className="ml-1 font-semibold text-gray-700">
                                            {hotelData.HotelDetails.rt}
                                        </span>

                                        <Star className="inline h-3.5 w-3.5 fill-amber-400 text-amber-400" />
                                    </div>
                                </div>
                                Check/Uncheck All
                                <div
                                    onClick={handleCheckAll}
                                    className={`flex h-5 w-5 cursor-pointer items-center justify-center rounded border transition-colors ${isAllChecked || isHotelChecked
                                        ? 'border-blue-500 bg-blue-500 text-white'
                                        : 'border-gray-300 bg-white'
                                        }`}
                                >
                                    {(isAllChecked || isHotelChecked) && (
                                        <Check className="h-3.5 w-3.5 stroke-[3]" />
                                    )}
                                </div>
                            </div>

                            {/* Cards */}
                            <div className="mt-4 space-y-3">

                                {hotelData.RoomInfo.map((item) => {
                                    const room = item.Rooms[0];
                                    const isChecked = selectedRooms.includes(item.RoomId);
                                    const cancellation = room.CancelArr?.[0];

                                    const quoteValue = quotes[item.RoomId];

                                    const finalPrice =
                                        quoteValue !== undefined &&
                                            quoteValue !== '' &&
                                            !isNaN(parseFloat(quoteValue))
                                            ? (parseFloat(quoteValue) + parseFloat(room.HotelRoomPrice))
                                            : room.HotelRoomPrice;

                                    return (
                                        <div
                                            key={item.RoomId}
                                            className={`relative rounded-xl border p-4 transition-all ${isChecked
                                                ? 'border-gray-200 bg-white shadow-sm'
                                                : 'border-gray-200 bg-gray-50/40 opacity-75'
                                                }`}
                                        >

                                            {/* Card Header */}
                                            <div className="flex items-start justify-between">
                                                <div>
                                                    <h4 className="text-sm font-bold text-gray-900 md:text-base">
                                                        {room.RoomCategory}
                                                    </h4>

                                                    {cancellation?.Isfullrefundallowed && (
                                                        <p className="mt-1 flex items-center gap-1 text-xs font-medium text-emerald-600">
                                                            <Check className="h-3.5 w-3.5 stroke-[2.5]" />
                                                            Free Cancellation before{' '}
                                                            {cancellation.LastCancellationDate}
                                                        </p>
                                                    )}

                                                    <p className="mt-1 text-xs text-gray-400">
                                                        {room.MealBase} |{' '}
                                                        {room.IsPan
                                                            ? 'PAN Required'
                                                            : 'PAN not Required'}
                                                    </p>
                                                </div>

                                                {/* Single Checkbox */}
                                                <div
                                                    onClick={() =>
                                                        handleSingleCheck(item.RoomId)
                                                    }
                                                    className={`flex h-5 w-5 cursor-pointer items-center justify-center rounded border transition-colors ${isChecked
                                                        ? 'border-blue-500 bg-blue-500 text-white'
                                                        : 'border-gray-300 bg-white'
                                                        }`}
                                                >
                                                    {isChecked && (
                                                        <Check className="h-3.5 w-3.5 stroke-[3]" />
                                                    )}
                                                </div>
                                            </div>

                                            {/* Pricing */}
                                            <div className="mt-4 flex flex-wrap items-center justify-between gap-4 border-t border-gray-100 pt-3 text-xs">

                                                {/* Dates */}
                                                <div className="flex items-center gap-4">
                                                    <div>
                                                        <span className="block text-gray-400">
                                                            Check-in
                                                        </span>

                                                        <span className="font-semibold text-gray-800">
                                                            {hotelData.searchQuery.searchQuery.checkinDate}
                                                        </span>
                                                    </div>

                                                    <span className="rounded-full bg-gray-100 px-2.5 py-1 font-medium text-gray-600">
                                                        {item.Nights} Days
                                                    </span>

                                                    <div>
                                                        <span className="block text-gray-400">
                                                            Check-out
                                                        </span>

                                                        <span className="font-semibold text-gray-800">
                                                            {hotelData.searchQuery.searchQuery.checkoutDate}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Price */}
                                                <div className="flex items-center gap-6">

                                                    {/* Original Price */}
                                                    <div>
                                                        <span className="block text-gray-400">
                                                            Excluding Markup
                                                        </span>

                                                        <span className="text-sm font-bold text-gray-900">
                                                            INR{' '}
                                                            {room.TotalFare.toLocaleString(
                                                                'en-IN',
                                                                {
                                                                    minimumFractionDigits: 2,
                                                                }
                                                            )}
                                                        </span>
                                                    </div>

                                                    {/* Quote */}
                                                    <div className="w-28">
                                                        <input
                                                            type="text"
                                                            inputMode="decimal"
                                                            placeholder="Your Markup"
                                                            value={quotes[item.RoomId] || ''}
                                                            onChange={(e) =>
                                                                handleQuoteChange(
                                                                    item.RoomId,
                                                                    e.target.value
                                                                )
                                                            }
                                                            className="w-full rounded-md border border-gray-300 px-2.5 py-1.5 text-xs text-gray-800 placeholder-gray-400 focus:border-orange-500 focus:outline-none"
                                                        />
                                                    </div>

                                                    {/* Final Price */}
                                                    <div className="text-right">
                                                        <span className="block text-gray-400">
                                                            Final Price
                                                        </span>

                                                        <span className="text-sm font-bold text-gray-900">
                                                            INR{' '}
                                                            {Math.round(
                                                                finalPrice
                                                            ).toLocaleString('en-IN')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* FIXED FOOTER */}
                        <div className="shrink-0 flex items-center justify-end gap-3 border-t border-gray-100 bg-white p-4 shadow-[0_-4px_12px_rgba(0,0,0,0.04)]">
                            {/* WhatsApp Button Component */}
                            <HotelWhatsAppShare
                                quotes={quotes}
                                hotelData={hotelData}
                                selectedRoomIds={selectedRooms}
                            />

                            {/* Send Mail Button */}
                            {/* <button
                                type="button"
                                className="flex w-auto items-center justify-center gap-2 rounded-lg border border-gray-200 px-4 py-2 text-xs font-semibold text-gray-700 transition hover:bg-gray-50"
                            >
                                <Mail className="h-[24] w-[24] text-blue-600" />
                                Send Mail
                            </button> */}

                            {/* Download PDF Button (if enabled) */}
                            {/* <button
                            type="button"
                            className="flex w-auto items-center justify-center gap-2 rounded-lg border border-gray-200 px-4 py-2 text-xs font-semibold text-gray-700 transition hover:bg-gray-50"
                        >
                            <Download className="h-4 w-4 text-gray-600" />
                            Download PDF
                        </button> */}
                        </div>
                    </div>
                </div>
            )}
            {resultLoading ? (
                <><HotelDetailsShimmer /></>
            ) : (
                <>
                    <HotelDetailsComponent handleScroll={handleScroll} roomRef={roomRef} HotelDetails={HotelDetails} RoomInfos={RoomInfos} searchQuery={searchQuery} handleHotelCheckout={handleHotelCheckout} setShowGuestPopup={setShowGuestPopup} />
                    <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 lg:grid-cols-1 gap-8">

                        <div className="lg:col-span-2 space-y-6">
                            <div className="sticky top-0 z-50 bg-white border-b shadow-sm">
                                <div className="max-w-7xl mx-auto px-4 flex justify-start gap-8 py-3 overflow-x-auto">
                                    {[
                                        { id: "hotels", label: "About Hotel", ref: abouthotelref },
                                        { id: "rooms", label: "Choose Room", ref: roomRef },
                                        { id: "facilities", label: "Facilities", ref: facilitiesRef },
                                        { id: "location", label: "Location", ref: locationRef },
                                        { id: "policy", label: "Hotel Policy", ref: policyRef }
                                    ].map(tab => (
                                        <button key={tab.id} onClick={() => handleScroll(tab.ref, tab.id)}
                                            className={`pb-2 text-sm font-medium border-b-2 transition-all ${activeTab === tab.id ? "border-blue-600 text-blue-600" : "border-transparent text-gray-600 hover:text-blue-600"}`}>
                                            {tab.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <section ref={abouthotelref} className="bg-white p-6 rounded-xl shadow">
                                <h2 className="text-xl font-semibold mb-4">About Hotel</h2>
                                <div className="space-y-4">
                                    {HotelDetails && HotelDetails.des.length > 0 && HotelDetails.des
                                        .filter((item) => item.key !== "Default" && typeof item.value === "string")
                                        .map((item, idx) => (
                                            <div key={idx}>
                                                <h3 className="font-semibold text-gray-800">{item.key}</h3>
                                                <p className="text-gray-600 text-sm">{item.value}</p>
                                            </div>
                                        ))}
                                </div>
                            </section>

                            <section ref={roomRef} className="bg-white p-6 rounded-xl shadow">
                                <div className="flex items-center justify-between">
                                    <h2 className="text-xl font-semibold text-gray-900">Choose Room</h2>
                                    <button
                                        onClick={() => setShowGuestPopup(true)}
                                        className="rounded-lg border flex border-blue-500 px-4 py-2 text-sm font-medium text-blue-600 transition hover:bg-blue-50"
                                    >
                                        <Share2 className="h-[20px] w-[20px] text-blue-600" />  Share
                                    </button>
                                </div>
                                <div className="space-y-4 mt-4">
                                    {RoomInfos && RoomInfos.length > 0 && RoomInfos.map((roomGroup, idx) => (
                                        roomGroup.Rooms.map((room, roomIdx) => (
                                            <div key={`${idx}-${roomIdx}`} onClick={() => setSelectedRoom(`${idx}-${roomIdx}`)} className={`flex gap-4 p-4 border rounded-lg cursor-pointer transition-all duration-200 ${selectedRoom === `${idx}-${roomIdx}` ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-400"}`}>

                                                <div className="w-24 h-24 bg-gray-200 rounded-lg flex-shrink-0">
                                                    <img src={(room.imgs && room.imgs[0]) || (roomGroup.images && roomGroup.images[0]?.url) || "/imagePlaceholder.png"} alt={room.RoomType} className="w-full h-full object-cover rounded-lg" onError={(e) => (e.target.src = "/imagePlaceholder.png")} />
                                                </div>

                                                <div className="flex-1">
                                                    <div className="mb-2">
                                                        <h3 className="font-semibold text-lg">{room.RoomType}</h3>
                                                        <p className="text-gray-600 text-sm flex items-center gap-1">
                                                            {room.MealBase} •
                                                            {roomGroup.IsPan ? (
                                                                <span className="text-red-600 font-medium flex items-center gap-1">
                                                                    <AlertCircle className="w-4 h-4" />
                                                                    PAN required
                                                                </span>
                                                            ) : (
                                                                <span className="text-green-600 flex items-center gap-1">
                                                                    <CheckCircle className="w-4 h-4" />
                                                                    No PAN required
                                                                </span>
                                                            )}
                                                        </p>


                                                        <div className="mt-2 flex flex-wrap gap-1.5">
                                                            {roomGroup?.bed_config?.configuration?.length > 0
                                                                ? roomGroup.bed_config.configuration.map(
                                                                    (val, index) =>
                                                                        val?.quantity > 0 && (
                                                                            <span
                                                                                key={index}
                                                                                className="flex items-center gap-1 rounded-md bg-slate-100 px-2 py-1 text-xs font-medium text-slate-600"
                                                                            >
                                                                                <Bed className="h-3.5 w-3.5" />
                                                                                {val.quantity} {val.type}
                                                                            </span>
                                                                        )
                                                                )
                                                                : roomGroup?.bed_config?.[0]?.quantity > 0 &&
                                                                roomGroup?.bed_config?.[0]?.type && (
                                                                    <span className="flex items-center gap-1 rounded-md bg-slate-100 px-2 py-1 text-xs font-medium text-slate-600">
                                                                        <Bed className="h-3.5 w-3.5" />
                                                                        {roomGroup.bed_config[0].quantity} {roomGroup.bed_config[0].type}
                                                                    </span>
                                                                )}
                                                            {roomGroup.occupancy?.[0] && (
                                                                <span className="flex items-center gap-1 rounded-md bg-slate-100 px-2 py-1 text-xs font-medium text-slate-600">
                                                                    {roomGroup?.occupancy?.[0]?.total > 0 && (
                                                                        <>
                                                                            <Users className="h-3.5 w-3.5" />
                                                                            <span>Fits {roomGroup.occupancy[0].total} guests</span>
                                                                        </>
                                                                    )}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {room.CancelArr?.[0] && (
                                                            <div className="flex items-center gap-1 text-xs text-emerald-600 font-medium bg-emerald-50/70 border border-emerald-100/50 rounded px-2 py-1 w-fit mt-1">
                                                                <CheckCircle size={13} className="shrink-0" />
                                                                <span>Free Cancellation before {room.CancelArr[0].LastCancellationDate}</span>
                                                            </div>
                                                        )}
                                                        <button
                                                            onClick={() => handleOpenModal(room.CancelArr)}
                                                            className="text-xs text-blue-600 hover:text-blue-800 font-semibold 
                                                                                        tracking-wide pt-1 transition-colors block"
                                                        >
                                                            Cancellation Policy
                                                        </button>
                                                    </div>

                                                    <div className="flex flex-wrap gap-4 mb-3">
                                                        {room.Extrabenefits && room.Extrabenefits.map((benefit, benefitIdx) => (
                                                            <div key={benefitIdx} className="flex items-center text-green-600 text-sm">
                                                                <i className="fas fa-check mr-1"></i>
                                                                <span>{benefit}</span>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className="flex justify-between items-center pt-3 border-t border-gray-200">
                                                        <div className="text-sm text-gray-600">
                                                            <span>{room.rooms || 1} Room(s)</span>
                                                            <span className="mx-2">•</span>
                                                            <span>{room.nights || roomGroup.Nights || 1} Night(s)</span>
                                                        </div>

                                                        <div className="flex items-center gap-4">
                                                            <div className="text-right">
                                                                <p className="font-semibold text-lg">{CurrencySymbol} {room?.HotelRoomPrice}</p>
                                                                {showCancellationPopup && roomGroup && (
                                                                    <CancellationPolicyPopup
                                                                        cancellationData={roomGroup.CancelArr}
                                                                        currencySymbol={CurrencySymbol}
                                                                        onClose={() => setShowCancellationPopup(false)}
                                                                    />
                                                                )}
                                                            </div>
                                                            <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 font-medium" onClick={() => handleHotelCheckout(roomGroup, room)}>
                                                                Book Now
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ))}
                                </div>
                            </section>
                            <section ref={facilitiesRef} className="bg-white p-6 rounded-xl shadow">
                                <h2 className="text-xl font-semibold mb-4">Facilities</h2>
                                <ul className="list-disc list-inside space-y-1 text-gray-700">
                                    {HotelDetails && HotelDetails.fl.length > 0 && HotelDetails.fl.map((f, idx) => <li key={f.id ?? idx}>{f.name}</li>)}
                                </ul>
                            </section>

                            <section ref={locationRef} className="bg-white p-6 rounded-xl shadow">
                                <h2 className="text-xl font-semibold mb-4">Location</h2>
                                {HotelDetails && HotelDetails?.gl?.lt && <iframe title="Hotel Location" width="100%" height="300" className="rounded-lg"
                                    src={`https://maps.google.com/maps?q=${HotelDetails?.gl?.lt},${HotelDetails?.gl?.ln}&z=15&output=embed`}>
                                </iframe>}
                            </section>

                            <section ref={policyRef} className="bg-white p-6 rounded-xl shadow">
                                <h2 className="text-xl font-semibold mb-4">Hotel Policy</h2>
                                {HotelDetails?.inst && HotelDetails?.inst.map((instval, fackey) => (
                                    <>
                                        <p className="font-bold">{instval.type}</p>
                                        <p className="">{instval.description}</p>
                                    </>
                                ))}
                                <p className="text-gray-700 mt-4">
                                    The standard check-in time is 12:00 PM and the standard check-out time is 11:00 AM. Early check-in or late check-out is strictly subjected to availability and may be chargeable by the hotel. Any early check-in or late check-out request must be directed and reconfirmed with hotel directly.

                                    Hotel Policy: Most hotels do not allow unmarried/unrelated couples to check-in. This is at the full discretion of the hotel management. No refund would be applicable in case the hotel denies check-in under such circumstances., Most hotels do not allow same city/local ID Proofs for check-in. Kindly check with your hotel about the same before checking in. This is at full discretion of the hotel management. No refund would be applicable in case the hotel denies check-in under such circumstances.
                                </p>
                            </section>
                        </div>

                        {/* <div className="relative">
                            <div className="sticky top-24">
                                <aside className="rounded-xl border border-gray-300 bg-white p-4 w-80">
                                    <div className="mb-4">
                                        <h3 className="text-lg font-bold text-gray-900">{HotelDetails && HotelDetails.name}</h3>
                                        <p className="text-xs text-gray-600 mt-1">{HotelDetails && HotelDetails?.ad?.adr} {HotelDetails && HotelDetails?.ad?.adr2},{HotelDetails && HotelDetails?.ad?.postalCode}</p>
                                    </div>

                                    <div className="mb-4">
                                        <div className="flex justify-between items-start mb-1">
                                            <span className="text-2xl font-bold text-gray-900">{CurrencySymbol} {RoomInfos && RoomInfos[0].HotelRoomPrice}</span>
                                        </div>
                                        <div className="text-xs text-gray-600 mb-2">{RoomInfos && RoomInfos.length > 0 && RoomInfos[0].Rooms.length} Room(s) 1 Night(s)</div>
                                        <div className="text-sm text-gray-700 font-medium">{RoomInfos && RoomInfos.length > 0 && RoomInfos[0]?.Rooms[0]?.RoomCategory}</div>
                                    </div>

                                    <div className="mb-4 p-3 bg-gray-100 rounded-lg">
                                        <div className="flex justify-between items-center mb-1">
                                            <span className="text-sm font-medium text-gray-700">{searchQuery && searchQuery.checkinDate}</span>
                                            <span className="text-sm font-medium text-gray-700">{searchQuery && searchQuery.checkoutDate}</span>
                                        </div>
                                        <div className="text-center text-xs text-gray-500">{RoomInfos && RoomInfos.length > 0 && RoomInfos[0].Rooms.length} Night(s)</div>
                                    </div>

                                    <button className="w-full h-12 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 mb-4" onClick={() => handleHotelCheckout(RoomInfos && RoomInfos[0])}>
                                        Book Now
                                    </button>

                                    <div className="border-t border-gray-200 pt-3">
                                        <div className="text-xs text-gray-500 text-center mb-1">
                                            CHECKIN : 12:00 PM / CHECKOUT : 11:00 AM
                                        </div>
                                        <div className="text-xs text-gray-400 text-center">
                                            Last Booked - 18 hours ago
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </div> */}
                    </div >
                </>
            )}


        </div >
    );
}

export default HotelDetails;